(angular => {
  "use strict";

  angular.module('App').factory('VoucherService', [
    'API',
    'FormRedirectService',
    VoucherService
  ]);

  function VoucherService(API, FormRedirectService) {

    const getVoucher = () => {
      return FormRedirectService.submit(`${API}/participant/voucher`);
    };

    return { getVoucher };
  }

})(angular);
